import React from "react";
import { Button } from "antd";
import { formatNumber } from "../libs/helper";

export const PreparingReportExportToast = ({ rowsWritten = 0 }) => (
  <div>
    <strong>Preparing SMS Transaction Details</strong>
    <p className="mb-0 mt-1 text-sm">
      {rowsWritten > 0
        ? `${formatNumber(rowsWritten)} rows written`
        : "You can keep using the dashboard while we prepare your file."}
    </p>
  </div>
);

export const ReadyReportExportToast = ({ onDownload }) => (
  <div>
    <strong>SMS Transaction Details report is ready</strong>
    <p className="mb-2 mt-1 text-sm">Your download has started.</p>
    <Button type="primary" size="small" onClick={onDownload}>
      Download again
    </Button>
  </div>
);
